/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Properties of an AWS EBS volume when discovered as a standalone resource. Present only when `resourceType` is set to `AWS_EBS_VOLUME`. 
*/
export class AwsEbsVolumeResource {
  /**
  * The EBS volume ID.
  */
  'volumeId': string;
  /**
  * The EBS volume type.
  */
  'volumeType': AwsEbsVolumeResourceVolumeTypeEnum;
  /**
  * The size of the volume in GiB.
  */
  'sizeGib': number;
  /**
  * The number of I/O operations per second (IOPS).
  */
  'iops'?: number;
  /**
  * The throughput in MiB/s (for gp3 volumes).
  */
  'throughputMiBs'?: number;
  /**
  * The state of the volume.
  */
  'state': AwsEbsVolumeResourceStateEnum;
  /**
  * The Availability Zone in which the volume is located.
  */
  'availabilityZone': string;
  /**
  * Whether the volume is encrypted.
  */
  'encrypted': boolean;
  /**
  * The Amazon Resource Name (ARN) of the AWS Key Management Service (KMS) key used to encrypt the volume.
  */
  'kmsKeyId'?: string;
  /**
  * Whether the encryption key is AWS-managed (true) or customer-managed (false).
  */
  'isAwsManagedKey'?: boolean;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "volumeId",
      "baseName": "volumeId",
      "type": "string",
      "format": ""
    },
    {
      "name": "volumeType",
      "baseName": "volumeType",
      "type": "AwsEbsVolumeResourceVolumeTypeEnum",
      "format": ""
    },
    {
      "name": "sizeGib",
      "baseName": "sizeGib",
      "type": "number",
      "format": "int32"
    },
    {
      "name": "iops",
      "baseName": "iops",
      "type": "number",
      "format": ""
    },
    {
      "name": "throughputMiBs",
      "baseName": "throughputMiBs",
      "type": "number",
      "format": ""
    },
    {
      "name": "state",
      "baseName": "state",
      "type": "AwsEbsVolumeResourceStateEnum",
      "format": ""
    },
    {
      "name": "availabilityZone",
      "baseName": "availabilityZone",
      "type": "string",
      "format": ""
    },
    {
      "name": "encrypted",
      "baseName": "encrypted",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "kmsKeyId",
      "baseName": "kmsKeyId",
      "type": "string",
      "format": ""
    },
    {
      "name": "isAwsManagedKey",
      "baseName": "isAwsManagedKey",
      "type": "boolean",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AwsEbsVolumeResource.attributeTypeMap;
  }

  public constructor() {
  }
}


export enum AwsEbsVolumeResourceVolumeTypeEnum {
  Standard = 'standard',
  Io1 = 'io1',
  Io2 = 'io2',
  Gp2 = 'gp2',
  Sc1 = 'sc1',
  St1 = 'st1',
  Gp3 = 'gp3'
}
export enum AwsEbsVolumeResourceStateEnum {
  Creating = 'creating',
  Available = 'available',
  InUse = 'in-use',
  Deleting = 'deleting',
  Deleted = 'deleted',
  Error = 'error'
}

